// extracted by mini-css-extract-plugin
export default {"mainClass":"candidates_mainClass__tK9Ly","h1":"candidates_h1__V5Ct4","tabClass":"candidates_tabClass__5WAfl"};